import {
    FichaFinanceiraAssistidoEntidade,
    ResumoContrachequeEntidade,
} from ".";

export class ContrachequeEntidade {
    public Rubricas: Array<FichaFinanceiraAssistidoEntidade>;
    public Proventos: Array<FichaFinanceiraAssistidoEntidade>;
    public Descontos: Array<FichaFinanceiraAssistidoEntidade>;

    public Resumo: ResumoContrachequeEntidade;
}
